/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


import { GlobalScenario } from './global-scenario-dto.model';
import { VehicleScenario } from './vehicle-scenario-dto.model';

/**
 * Model to represent a Global Scenario Request DTO
 */
export class GlobalScenarioRequest {
  globalScenario: GlobalScenario;
  vehicleScenarios: VehicleScenario[];
}
